"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HOURS_LIMIT_FOR_UNAGGREGATED_INTERVAL = exports.HOURS_LIMIT_FOR_HOURLY_INTERVAL = void 0;
exports.HOURS_LIMIT_FOR_HOURLY_INTERVAL = 760;
exports.HOURS_LIMIT_FOR_UNAGGREGATED_INTERVAL = 74;
//# sourceMappingURL=maxDaysForIntervals.js.map